import Mutations from '../../odata/mutations';

export default { ...new Mutations('emailLog'), ...new Mutations('emailLogs') };
